import Vue from 'vue'

const AuthEventBus = new Vue()

export default AuthEventBus
